import { useState, useEffect } from "react";

import './UsersDashboard.css';

import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import { SvgAddNewData, SvgCancel, SvgDelete, SvgEdit, SvgHistoric, SvgSearch, SvgUser, SvgUserDisabled } from "services/SvgFile";

import { SetListPag } from "interface/Page";
import { SetModalData, SetModalState } from "interface/PopUp";
import { GetUserData, RegisterUserData, UnRegisterUserPage } from "interface/Users";
import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "interface/Data";

export default function Page_UsersDash(props){

    const [ search, setSearch ]     = useState('');
    const [ userId, setUserId ]     = useState(GetUserData('id'));
    const [ showData, setShowData ] = useState(GetDataPage('access_dash'));
    const [ listUser, setListUser ] = useState(InitialData('all'));
    const [ listOff, setListOff ]   = useState(InitialData('deleted'));

    const [ itensPage, setItensPage ] = useState(50);
    const [ showPage, setShowPage ]   = useState(0);

    const page         = Math.ceil(listUser.length / itensPage);
    const startItens   = showPage * itensPage;
    const endItens     = startItens + itensPage;
    const currentItens = listUser.slice(startItens, endItens);

    function InitialData(type){
        if(type == "all"){
            const newData = GetDataPage('access_dash').filter(item => item.status !=2);
            return newData;
        }
        if(type == "deleted"){
            const newData = [];
            GetDataPage('access_dash').map((elem, index)=>{
                if(elem.status == 2){
                    newData.push({ "id": elem.id, "type": "access_dash", "title": elem.name, "removed_name": elem.removed_name, "removed_date": elem.removed_date })
                }
            });
            return newData;
        }
    }
    
    function SearchInput(value){
        const newList = [];
        if(value){
            GetDataPage('access_dash').forEach(item =>{
                if(item.status !=2){
                    if(item.name.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.email.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                }
            });
            const duplicate = newList.filter((item, index) => newList.indexOf(item) === index);
            setListUser(duplicate);
        }else {
            setListUser(InitialData('all'));
        }
        setSearch(value);
    }

    function OpenFile(type, file){
        SetModalData('ShowFile', { "typeFile": "alone", "type": type, "file": file });
        SetModalState('ShowFile', true);
    }

    function AltAccess(status, id, value){
        SetModalData('Confirmation', { "origin": "access_dash", "type" : "alt_status_data", "status": status, "id" : id, "name": value });
        SetModalState('Confirmation', true);
    }

    function PageClick(idPage){
        SetListPag('currentPage', 'access_dash_details');
        SetListPag('currentPageId', idPage);
    }

    useEffect(()=>{
        RegisterUserData('id', setUserId);
        RegisterDataPage('access_dash', setShowData);

        return ()=>{
            UnRegisterUserPage('id', setUserId);
            UnRegisterDataPage('access_dash', setShowData);
        };
    }, []);

    useEffect(()=>{
        setListUser(InitialData('all'));
        setListOff(InitialData('deleted'));
    }, [showData]);

    return(
        <div className="Page_UsersDash">
            <div className="new_block">
                <div className="input_search">
                    <SvgSearch color="#606875" className="icons_search" />
                    <input type="text" className="search" onChange={ (e)=>{ SearchInput(e.target.value) } } value={ search } required placeholder="buscar" />
                </div>
                <div className="list_opt_alt_page">
                    {
                        listOff.length > 0 ? 
                        <div className="" onClick={ ()=>{ SetModalData('Historic', { "listData": listOff, "type": "alt_status_data" } ); SetModalState('Historic', true); }}>
                            <SvgHistoric className="icons" color="#2D3C53"/>
                        </div> : null
                    }
                    <div className="div_add_new_data" onClick={ ()=>{ PageClick(0) } }>
                        <div className="new_data_add">
                            <SvgAddNewData className="icons" color="#ffffff" />
                        </div>
                        <div className="name_btn_add">Usuários</div>
                    </div>
                </div>
            </div>
            <div className="">
                <table cellPadding="0" cellSpacing="0">
                    <thead>
                        <tr>
                            <th width="20" align="center">#</th>
                            <th>Nome</th>
                            <th className="td_hide" width="200">E-mail</th>
                            <th className="td_hide" width="180">Acesso</th>
                            <th width="90" align="right">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentItens.map((elem, index)=>{
                                return(
                                    <tr key={ index }>
                                        <td align="center">{ startItens + index + 1 }</td>
                                        <td>{ elem.name }</td>
                                        <td className="td_hide">{ elem.email }</td>
                                        <td className="td_hide" align="left">
                                            <div>
                                                {
                                                    elem.access == 1 ? "Administrador" : 
                                                    elem.page.map((elem_1, index_1)=>{
                                                        return (
                                                            <div className="" key={ index_1 }>{ elem_1.name }</div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </td>
                                        <td align="right">
                                            <div className="list_opt">
                                                {
                                                    userId != elem.id ?
                                                    <>
                                                        {
                                                            elem.status == 0 ?
                                                            <div onClick={ ()=>{ AltAccess(1, elem.id, elem.name) } } data-tooltip-id={ "id_access_" + elem.id } data-tooltip-content="Liberar acesso" data-tooltip-place="top">
                                                                <SvgUserDisabled color="#2D3C53" className="icons"/>
                                                            </div> :
                                                            <div onClick={ ()=>{ AltAccess(0, elem.id, elem.name) } } data-tooltip-id={ "id_access_" + elem.id } data-tooltip-content="Remover acesso" data-tooltip-place="top">
                                                                <SvgCancel color="#2D3C53" className="icons"/>
                                                            </div>
                                                        }
                                                        <Tooltip id={ "id_access_" + elem.id } />
                                                        <div onClick={ ()=>{ AltAccess(2, elem.id, elem.name) } } data-tooltip-id={ "id_delete_" + elem.id } data-tooltip-content="Deletar usuário" data-tooltip-place="top">
                                                            <SvgDelete color="#F00000" className="icons"/>
                                                        </div>
                                                        <Tooltip id={ "id_delete_" + elem.id } />
                                                    </> : null
                                                }
                                                <div onClick={ ()=>{ PageClick(elem.id) } } data-tooltip-id={ "id_edit_" + elem.id } data-tooltip-content="Editar usuário" data-tooltip-place="top">
                                                    <SvgEdit color="#2D3C53" className="icons"/>
                                                </div>
                                                <Tooltip id={ "id_edit_" + elem.id } />
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                {
                    listUser.length >= 50 ?
                    <div className="list_pages">
                        {
                            Array.from(Array(page), (item, index)=>{
                                return(
                                    <div className={ showPage == index ? "numb_page" : "numb_page page_active" } key={ index } onClick={ (e)=>{ setShowPage(index) } }>
                                        { index + 1 }
                                    </div>
                                )
                            })
                        }
                    </div> : null
                }
            </div>
        </div>
    )
}